<main id="main" class="list-height volume-issue-main">
    <section id="" class="pt-0 volume-issue-sec" aria-label=""> <!--[style.height.px]="containerHeight"-->
        <div class="container volume-issue-container">
            <div class="row mb-4" *ngIf="themeSettingsData">
                <span class="article-breadcrumb-sec"
                    *ngIf="(volumesAndIssues || showCurrentArticlesOnly || thematicOnly)">
                    <span (click)="goToPage('')" (keyup.enter)="goToPage('')" (keyup.space)="goToPage('')"
                        class="breadcrumb-nav" title=" {{themeSettingsData.banner_heading}}">
                        <i><span class="nav-string nav-string-home"> {{themeSettingsData.banner_heading}}</span></i>
                        <fa-icon aria-hidden="true" class="angle-icon" [icon]="['fas', 'angle-right']">
                        </fa-icon>
                    </span>
                    <span *ngIf="volumesAndIssues">
                        {{'journal_listing.volume_issue'|translate}}
                    </span>
                    <span *ngIf="showCurrentArticlesOnly">
                        Current Articles
                    </span>
                    <span *ngIf="thematicOnly" (click)="goToPage('thematic-collections')" class="breadcrumb-nav">
                        <span class="nav-string">{{'app_header.special_issues_jba'| translate}}</span>
                        <fa-icon *ngIf="volume_id" aria-hidden="true" class="angle-icon"
                            [icon]="['fas', 'angle-right']">
                        </fa-icon>
                    </span>
                    <span *ngIf="thematicOnly && volume_id">
                        Volume {{volume_id}}
                    </span>
                </span>


                <div class="volume-head-title" data-aos="fade-up" *ngIf="!loading">
                    <h1 tabindex="0"> {{volume_heading|translate}}</h1>
                </div>
            </div>
            <!-- loading starts -->
            <div *ngIf="loading">
                <div class="row mb-4">
                    <div class="volume-head-title d-flex justify-content-center" data-aos="fade-up" *ngIf="loading">
                        <h1 class="content-loader w-50">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h1>
                    </div>
                </div>
                <div class="card mb-4" *ngFor="let volume of volum_list;">
                    <div class="card-header-loading">
                        <div class="row pt-1">
                            <div class="col-sm-11 col-md-11 head-content-div">
                                <span class="content-loader content-loader-heading">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </div>
                            <div class="col-sm-1 col-md-1">
                                <span class="content-loader">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </div>
                        </div>
                    </div>
                    <ng-container>

                        <div class="card-body pb-0 pt-1">
                            <span class="text-black row">
                                <div class="col-sm-11 col-md-11 contet-div">
                                    <span class="issue-label pt-2 content-loader"
                                        style="cursor:pointer;"><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                                    </span>
                                    <p class="pt-3 content-loader" tabindex="0">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </p>
                                </div>
                                <div class="col-sm-1 col-md-1 icon-div">
                                    <span class="icon-span content-loader">
                                        &nbsp;&nbsp;&nbsp;
                                    </span>
                                </div>
                            </span>

                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- loading ends -->

            <div *ngIf="!loading">
                <div class="card mb-4 volume-card" *ngFor="let volume of volumeData;let i=index;">
                    <div class="card-header">
                        <div class="row pt-1">
                            <!-- <a [routerLink]="['/articles/'+volume.volume+'/non-issue/page/1']" class="text-black"> -->
                            <div class="col-10 col-md-11 head-content-div">
                                <span class="file-icon-label">
                                    <fa-icon class="iconcls icon-pointer" aria-hidden="true"
                                        [icon]="['fas', 'file-lines']">
                                    </fa-icon>
                                </span>
                                <ng-container *ngIf="isNonIssuePresent(volume)">
                                    <span class="volume-head" title="{{ 'app_header.volume' | translate }}
                                    {{ volume.volume }}, {{ volume.year }}">
                                        <span class="h4-span" tabindex="0" *ngIf="volume.fasttrack === false">
                                            {{ 'app_header.volume' | translate }}
                                            {{ volume.volume }}, {{ volume.year }}
                                        </span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="!isNonIssuePresent(volume)">
                                    <span class="h4-span" tabindex="0" *ngIf="volume.fasttrack === false">
                                        {{ 'app_header.volume' | translate }}
                                        {{ volume.volume }}, {{ volume.year }}
                                    </span>
                                </ng-container>


                                <!-- <a class="volume-head" [routerLink]="[setNonIssueLink(volume.volume)]"><span class="h4-span" tabindex="0" *ngIf="volume.fasttrack === false">
                                    {{'app_header.volume'|translate}}
                                    {{volume.volume}}, {{volume.year}} </span></a> -->
                                <span class="h4-span" tabindex="0" *ngIf=" volume.volume === '0' ">
                                    Fast Track </span>

                            </div>
                            <div class="col-2 col-md-1 head-button d-flex justify-content-center">
                                <!-- <span class="" aria-hidden="true"> -->
                                <fa-icon class="iconcls icon-minus" aria-hidden="true"
                                    [icon]="['fas', isMinus[i] ? 'circle-plus' : 'circle-minus']"
                                    (click)="isMinus[i]=!isMinus[i];" (keyup.enter)="isMinus[i]=!isMinus[i];"
                                    (keyup.space)="isMinus[i]=!isMinus[i];"></fa-icon>
                                <!-- </span> -->
                            </div>
                            <!-- </a> -->
                        </div>
                    </div>
                    <ng-container *ngIf="!isMinus[i]">
                        <div class="row pt-1 text-black card-body" *ngIf="volume.non_issues.length>0">
                            <ng-container *ngFor="let non_issues of volume.non_issues">
                                <div class="col-10 col-md-11  contet-div mt-3 ps-4">
                                    <a *ngIf="non_issues.regular_count && non_issues.regular_count>0" class="text-black"
                                        [routerLink]="setNonIssueLink(volume.volume)">
                                        <u>
                                            <p class="thematic_collection">
                                                Regular articles
                                            </p>
                                        </u>
                                    </a>
                                    <p *ngIf="non_issues.articles_count && non_issues.articles_count>0"
                                        class="pt-1 issue-content-label" tabindex="0">
                                        {{non_issues.year}} | {{'journal_volume_listing.total_artcles' | translate}}:
                                        {{non_issues.articles_count}}

                                    </p>
                                </div>
                                <div class="col-2 col-md-1 icon-div d-flex justify-content-center align-items-center">
                                    <span class="icon-span">
                                        <fa-icon class="iconcls file-icon icon-pointer" *ngIf="!non_issues.cover_image"
                                            aria-hidden="true" [icon]="['fas', 'file-lines']">
                                        </fa-icon>
                                        <img class="card-img-top" *ngIf="non_issues.cover_image" tabindex="0"
                                            src="{{issue_cover_image+'/'+volume.volume+'/'+non_issues.issue+'/'+non_issues.cover_image}}">
                                        <!-- <fa-icon class="iconcls file-icon icon-pointer" aria-hidden="true"
                                            [icon]="['fas', 'file-lines']">
                                        </fa-icon> -->
                                    </span>
                                </div>
                            </ng-container>
                        </div>

                        <ng-container *ngFor="let issues of volume.issue_issues">
                            <div class="card-body pb-0 pt-1"
                                *ngIf="!(volume.volume == '11' && volume.thematic && volume.supplementary) || (issues.issue && issues.issue.toLowerCase().includes('s'))">
                                <div class="row pt-1 text-black">
                                    <div class="col-12 content-div mt-3 ps-4">
                                        <ng-container>
                                            <span class="pt-2 issue-label">{{ changeIssue(issues.issue) }}</span>
                                        </ng-container>

                                        <!-- For regular articles -->
                                        <ng-container *ngIf="issues.regular_count && issues.regular_count > 0">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <a class="text-black"
                                                    [routerLink]="setRegularIssueLink(volume.volume, issues.issue)">
                                                    <u>
                                                        <p class="thematic_collection">
                                                            Regular articles
                                                        </p>
                                                    </u>
                                                </a>
                                                <span class="icon-span" *ngIf="!issues.cover_image">
                                                    <fa-icon class="iconcls file-icon icon-pointer" aria-hidden="true"
                                                        [icon]="['fas', 'file-lines']"></fa-icon>
                                                </span>
                                                <img *ngIf="issues.cover_image" class="card-img-top" tabindex="0"
                                                    src="{{ issue_cover_image + '/' + volume.volume + '/' + issues.issue + '/' + issues.cover_image }}">
                                            </div>
                                            <p class="issue-content-label" tabindex="0">
                                                {{ issues.year }} | {{ 'journal_volume_listing.total_artcles' |
                                                translate
                                                }}: {{ issues.regular_count }}
                                            </p>
                                        </ng-container>
                                        <!-- Regular articles end -->

                                        <!-- For thematic articles -->
                                        <ng-container *ngIf="issues.thematic.length > 0">
                                            <ng-container *ngFor="let thematic_data of issues.thematic">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <a class="text-black"
                                                        [routerLink]="[setThematicLink(volume.volume, issues.issue,thematic_data.thematic_id)]"
                                                        title="{{ thematic_data.thematic_collection }}">
                                                        <u>
                                                            <p class="pt-3 thematic_collection">
                                                                {{ thematic_data.thematic_collection }}
                                                            </p>
                                                        </u>
                                                    </a>
                                                    <span class="icon-span" *ngIf="!issues.cover_image">
                                                        <fa-icon class="iconcls file-icon icon-pointer"
                                                            aria-hidden="true" [icon]="['fas', 'file-lines']"></fa-icon>
                                                    </span>
                                                    <img *ngIf="issues.cover_image" class="card-img-top" tabindex="0"
                                                        src="{{ issue_cover_image + '/' + volume.volume + '/' + issues.issue + '/' + issues.cover_image }}">
                                                </div>
                                                <p *ngIf="thematic_data?.thematic_collection_edited_by">
                                                    edited by {{ thematic_data.thematic_collection_edited_by }}
                                                </p>
                                                <p class="issue-content-label" tabindex="0">
                                                    {{ issues.year }} | {{ 'journal_volume_listing.total_artcles' |
                                                    translate
                                                    }}: {{ thematic_data.thematic_count }}
                                                </p>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                                <a *ngIf=" issues.issue === '0' && volume.fasttrack === true"
                                    [routerLink]="['/articles/fasttrack/page/1']" class="text-black row"
                                    title="Fast Track">
                                    <div class="col-sm-10 col-md-11 contet-div">
                                        <span class="pt-2 issue-label" style="cursor:pointer;"
                                            *ngIf=" issues.issue === '0'">
                                            Fast Track </span>
                                        <p *ngIf="issues.articles_count && issues.articles_count>0" class="pt-3"
                                            tabindex="0">
                                            {{issues.year}} | {{'journal_volume_listing.total_artcles' | translate}}:
                                            {{issues.articles_count}}
                                        </p>
                                    </div>
                                    <div class="col-sm-2 col-md-1 col-lg-2 icon-div" aria-hidden="true">
                                        <span class="icon-span">
                                            <fa-icon class="iconcls file-icon icon-pointer" *ngIf="!issues.cover_image"
                                                aria-hidden="true" [icon]="['fas', 'file-lines']">
                                            </fa-icon>
                                            <img class="card-img-top" *ngIf="issues.cover_image" tabindex="0"
                                                src="{{issue_cover_image+'/'+volume.volume+'/'+issues.issue+'/'+issues.cover_image}}">
                                            <!-- <fa-icon class="iconcls icon-pointer" aria-hidden="true"
                                            [icon]="['fas', 'file-lines']">
                                        </fa-icon> -->
                                        </span>
                                    </div>
                                </a>

                            </div>
                        </ng-container>
                    </ng-container>
                </div>
                <div *ngIf="!volume_final" class="d-flex justify-content-center p-3">
                    <span> Click</span>
                    <a class="outer-link pl-1 pr-1 click-here" target="_blank"
                        href="https://www.thebritishacademy.ac.uk/publishing/journal-british-academy/volumes-and-issues/"
                        title="https://www.thebritishacademy.ac.uk/publishing/journal-british-academy/volumes-and-issues/">
                        here
                    </a>
                    <span> for volumes 1-10</span>
                </div>
            </div>
            <div class="card mb-4" *ngIf="volumDataLength===0">
                <div style="display: flex; flex-direction: column; align-items: center;">
                    <img class="no-data-found-img" src="assets/images/not_found_img/no_data_1.webp" alt="">
                    <h2 class="card-title text-head-size">
                        No Data Found</h2>>
                </div>

            </div>
        </div>
    </section>
</main>